<template>
  <base-dialog
    data-testid="chatDeleteDialog.delete-dialog"
    max-width="400"
    type="delete"
    dialog-id="chatDeleteDialog"
    @complete-dialog="onDelete"
    @cancel-dialog="onCancel"
  >
    <template #content>
      <div>Are you sure you want to delete the content of this chat?</div>
    </template>
    <template #footer>
      <v-btn-delete-action data-testid="chatDeleteDialog.cancel-button" @click="onCancel"> Cancel </v-btn-delete-action>
      <v-btn-delete-action-CTA data-testid="chatDeleteDialog.delete-button" @click="onDelete">
        Delete
      </v-btn-delete-action-CTA>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import BaseDialog from "../../shared/BaseDialog.vue";

const emit = defineEmits(["cancel", "delete"]);

function onCancel() {
  emit("cancel");
}

async function onDelete() {
  emit("delete");
}
</script>
